/* eslint-disable no-param-reassign */
import router from '@/router';
import isEmpty from 'lodash.isempty';
import { authAPI } from '@/api';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const GET_USER = 'GET_USER';
export const CLEAN_AUTH = 'CLEAN_AUTH';

const SET_AUTHENTICATING = 'SET_AUTHENTICATING';
const SET_TOKEN = 'SET_TOKEN';
const SET_USER = 'SET_USER';

const LOCALSTORAGE_TOKEN_NAME = 'token';
const LOCALSTORAGE_USER = 'user';

const auth = {
  namespaced: true,

  state: {
    authenticating: false,
    token: localStorage.getItem(LOCALSTORAGE_TOKEN_NAME) || null,
    authenticated: !!localStorage.getItem(LOCALSTORAGE_TOKEN_NAME),
    user: JSON.parse(localStorage.getItem(LOCALSTORAGE_USER)) || null,
  },

  getters: {
    isLoggedIn: ({ token }) => !!token,

    isAdmin: ({ user }) => user && !!user.user_roles.includes('admin'),

    isTasador: ({ user }) => user && !!user.user_roles.includes('tasador'),

    isColaborador: ({ user }) => user && !!user.user_roles.includes('colaborador'),

    roles: ({ user }) => {
      if (user) {
        return user.user_roles;
      }
      return [];
    },

    can: (state, getters) => (roles = []) => {
      if (isEmpty(roles)) {
        return true;
      }

      return roles.some(role => getters.roles.includes(role));
    },
  },

  mutations: {
    [SET_AUTHENTICATING](state, bool) {
      state.authenticating = bool;
    },

    [SET_TOKEN](state, token) {
      state.token = token;
    },

    [SET_USER](state, user) {
      state.user = user;
    },

    [CLEAN_AUTH](state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem(LOCALSTORAGE_TOKEN_NAME);
      localStorage.removeItem(LOCALSTORAGE_USER);
    },
  },

  actions: {
    async [LOGIN]({ commit, getters }, { username, password }) {
      commit(SET_AUTHENTICATING, true);

      try {
        const {
          data: { token, user },
        } = await authAPI.login({ username, password });

        commit(SET_TOKEN, token);
        localStorage.setItem(LOCALSTORAGE_TOKEN_NAME, token);

        commit(SET_USER, user);
        localStorage.setItem(LOCALSTORAGE_USER, JSON.stringify(user));

        if (getters.isAdmin) {
          router.replace({ name: 'home' });
        } else {
          router.replace({ name: 'visitsSchedule' });
        }

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        commit(SET_AUTHENTICATING, false);
      }
    },

    async [LOGOUT]({ commit }) {
      await authAPI.logout();
      commit(SET_TOKEN, null);
      localStorage.removeItem(LOCALSTORAGE_TOKEN_NAME);
      commit(SET_USER, null);
      localStorage.removeItem(LOCALSTORAGE_USER);

      router.push({ name: 'login' });
    },

    async [GET_USER]({ commit }) {
      try {
        const {
          data: { user },
        } = await authAPI.getUser();

        commit(SET_USER, user);
        localStorage.setItem(LOCALSTORAGE_USER, JSON.stringify(user));

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};

export default auth;
